import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DateService {
    public date: BehaviorSubject<moment.Moment> = new BehaviorSubject(moment());

    changeMonth(dir: number) {
        const value = this.date.value.add(dir, 'month');
        this.date.next(value);
    }

    changeWeek(dir: number) {
        const value = this.date.value.add(dir, 'week');
        this.date.next(value);
    }

    changeYear(dir: number) {
        const value = this.date.value.add(dir, 'year');
        this.date.next(value);
    }

    changeDate(date: moment.Moment) {
        const value = this.date.value.set({
            date: date.date(),
            month: date.month(),
            year: date.year()
        });
        this.date.next(value);
    }
}
